import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { All_PENDING_INVOICES_QUERY_KEY } from "~/modules/billing/api/pendingInvoice/pendingInvoiceQueries.ts";
import { PROJECT_QUERY_KEY } from "~/modules/project/api/project/projectQueries.ts";
import type { Project } from "~/modules/project/api/project/projectTypes.ts";
import UpdateProjectBillingInformationForm
	from "~/modules/project/components/ProjectDetailsView/components/ProjectOverviewContent/components/ProjectBillingInformationSection/components/UpdateProjectBillingInformationSidebar/UpdateProjectBillingInformationForm";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	projectData: Project;
};

const UpdateProjectBillingInformationSidebar = ({
	isOpen,
	onClose,
	projectData,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async (billOrdersSeparatelyChanged:boolean) => {
		if(billOrdersSeparatelyChanged){
			await queryClient.refetchQueries({queryKey:All_PENDING_INVOICES_QUERY_KEY})
		}
		await queryClient.refetchQueries({queryKey:PROJECT_QUERY_KEY(projectData.id)});
		onClose();
	}, [onClose, projectData.id, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateProjectBillingInformationForm onCancel={onClose}
															onSuccess={handleSuccess}
															projectData={projectData} />}
		</Sidebar>
	);
};

export default UpdateProjectBillingInformationSidebar;
